import VirtualTable from './VirtualTable';

export default VirtualTable;
